import { Box } from "@mui/material";
import PropTypes from "prop-types";
export const LoadingWaveDots = ({ label = "Loading" }) => (
  <Box
    component="span"
    role="status"
    aria-label={label}
    sx={{
      display: "inline-flex",
      alignItems: "center",
      gap: "3px",
      lineHeight: 1,
      verticalAlign: "middle",
      "@keyframes member-details-dot-wave": {
        "0%, 60%, 100%": {
          transform: "translateY(0)",
          opacity: 0.35,
        },
        "30%": {
          transform: "translateY(-2px)",
          opacity: 1,
        },
      },
      "& .loading-wave-dot": {
        width: "4px",
        height: "4px",
        borderRadius: "50%",
        backgroundColor: "#403C6F",
        animation: "member-details-dot-wave 1s ease-in-out infinite",
      },
      "& .loading-wave-dot:nth-of-type(2)": {
        animationDelay: "0.14s",
      },
      "& .loading-wave-dot:nth-of-type(3)": {
        animationDelay: "0.28s",
      },
    }}
  >
    <Box component="span" className="loading-wave-dot" aria-hidden="true" />
    <Box component="span" className="loading-wave-dot" aria-hidden="true" />
    <Box component="span" className="loading-wave-dot" aria-hidden="true" />
  </Box>
);

LoadingWaveDots.propTypes = {
  label: PropTypes.string,
};
